let CmnMap = {}

CmnMap.install = function install (Vue) {
    Vue.component('cmn-base-map', () => import('./CmnBaseMap'))
    Vue.component('cmn-draw-map', () => import('./CmnDrawMap'))

    Vue.component('cmn-map-marker', () => import('./CmnMapMarker'))

    Vue.component('cmn-search-map', () => import('./CmnSearchMap'))
}

export default CmnMap


// WEBPACK FOOTER //
// ./application/assets/js/site/components/CmnMap/index.js